<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">A<span class="small">CKNOWLEDGEMENTS</span></p>
<p class="noindent">Charles Witte Waring III, editor of the <i>Charleston Mercury</i>, for permitting adaptation of articles that first appeared in the <i>Mercury</i> and for giving me the opportunity to get to know Charleston better.</p>
<p class="indent">Marie Ferrara, Anne Bennett, Claire Fund, Angela Flenner, Deborah Larsen, Sam Stewart and John White of the College of Charleston Special Collections Library, who have provided years of assistance and friendship.</p>
<p class="indent">Carl Borick, assistant director, Jennifer Scheetz, archivist, and Jan Hiester, registrar, of the Charleston Museum for invaluable support throughout the years.</p>
<p class="indent">Margaret (Marwee) Middleton Rivers, who left behind a treasury of writings, some of which are included in this volume.</p>
<p class="indent">Mendel Rivers Jr., for the story about Colonel Joseph Evans Jenkins at the Secession Convention.</p>
<p class="indent">Dorothy Middleton Anderson, who introduced me to A. Toomer Porter and <i>Hampton and His Red Shirts</i>.</p>
<p class="indent">Frank Barnwell, Joseph Cockrell and Fleetwood Hassell, for research on the Charleston Bible Society.</p>
<p class="indent">Quentin Baxter and Jack McCrae, for background information on Lowcountry music and Charleston jazz.</p>
<p class="indent">Amelia P. Cathcart, Ruth Knopf and Jane Waring, for introducing me to the world of heritage roses.</p>
<p class="indent">Charles (Charlie) Henry Drayton III and Anne Drayton Nelson, for insights about the Drayton family.</p>
<p class="indent">Jim and Ann Edwards, who shared their history-making life experiences.</p>
<p class="indent">Helen Pringle Gibbs, who patiently helped edit and provided information about the Ball family.</p>
<p class="indent">To Langhorne Moultrie Howard, for sharing her mother’s efforts to save Marshlands and a peek at her father’s love of aviation and love for our country.</p>
<p class="indent">Harriott Pinckney Means Johnson, for her research about the railroad contributions of the Parsons family.</p>
<p class="indent">Dr. George W. McDaniel, Kristine Morris and Natalie Baker, for invaluable assistance with Drayton Hall’s history.</p>
<p class="indent">Fred MaDan, for background on 93 Rutledge Avenue.</p>
<p class="indent">Bert and Helen Pruitt, for providing information on 54 Meeting Street and its builder, Timothy Ford.</p>
<p class="indent">Jane Thornhill Schachte, Jane Lucas Thornhill and Elizabeth Jenkins Young and her family, for sharing their rich heritage.</p>
<p class="indent">Ted Stern, for sharing his exceptional life story.</p>
<p class="indent">Robert Stockton, <i>News and Courier</i>’s “Do You Know Your Charleston” columnist and professor of architecture and history at the College of Charleston, for keeping me on track.</p>
<p class="indent">Seabrook Wilkerson, for helpful editing and support.</p>
<p class="indent">To the wonderful gang at The History Press who helped with this book: Jessica Berzon, Katie Parry, Dan Watson, Ryan Finn, Julie Foster, Natasha Momberger, Jamie Barreto, Adam Ferrell and Brittain Phillips.</p>
<p class="indent">To those who helped along the way: Wayne Braverman, Colby Broadwater, Nick Butler, Marion and Wayland Cato, Richard Donohoe, Edward Good, Christopher Liberatos, Martha Meeker, Candice Solyan, Evan Thompson, Lish Thompson, Rutledge Young Jr. and Rutledge Young III.</p>
<p class="right">Margaret (Peg) Middleton Rivers Eastman</p>
<p class="right1">June 15, 2011</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgement.vue?2062def1